/* import __COLOCATED_TEMPLATE__ from './legal.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { ProductName } from '@banking/ui/models/checking/product-positioning';
import { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { select } from '@banking/ui/services/investments-workflow';
import { isInvestmentAccountFullyCreated } from '@banking/ui/workflows/investments';
import { htmlSafe } from '@ember/template';
let Legal = (_dec = select(isInvestmentAccountFullyCreated), (_class = class Legal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "features", _descriptor3, this);
    _initializerDefineProperty(this, "storedBalanceProductPositioning", _descriptor4, this);
    _initializerDefineProperty(this, "isInvestmentAccountFullyCreated", _descriptor5, this);
  }
  get canAccessSfsSavings() {
    return this.features.isEnabled('banking/access_sfs_savings');
  }
  get canAccessSquareInvest() {
    return this.features.isEnabled('banking/access_bitcoin_investments') || this.isInvestmentAccountFullyCreated;
  }
  get legalDisclosures() {
    const disclosures = [];
    // NOTE(steckel): Legal should not be tied to product-positioning, though
    // it does have a relationship.
    // We'll need a new abstraction for this in the future.
    if (this.storedBalanceProductPositioning.productName === ProductName.CheckingAndDebit) {
      disclosures.push(this.intl.t('banking.launchpad.legal.storedBalance.checkingAndDebit'));
    }
    if (this.canAccessSfsSavings) {
      disclosures.push(this.intl.t('banking.launchpad.legal.savings'));
    }
    // Only show this footer if there is a loan offer and the user is from the US, according
    // to Legal in https://jira.sqprod.co/browse/CINTL-1304.
    if (this.args.hasLoanOffer && Country[this.userInfo.countryCode] === Country.US) {
      disclosures.push(this.intl.t('banking.launchpad.legal.loans'));
    }
    if (this.canAccessSquareInvest) {
      disclosures.push(this.intl.t('banking.launchpad.legal.invest'));
    }
    return htmlSafe(disclosures.join('</br></br>'));
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "storedBalanceProductPositioning", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isInvestmentAccountFullyCreated", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { Legal as default };